import { motion } from "framer-motion";
import { Layout } from "@/components/Layout";

export default function CookiePolicy() {
  return (
    <Layout>
      <div className="prose prose-invert max-w-4xl mx-auto">
        <h1 className="text-2xl font-pixel mb-8 text-[#9333EA]">Cookie Policy</h1>
        <div className="space-y-8 text-xs leading-relaxed text-gray-400">
          <section>
            <h2 className="text-base font-pixel mb-4 text-[#9333EA]">What Are Cookies?</h2>
            <p className="mb-4">Cookies are small text files that are stored on your device when you visit our website. They help us provide you with a better experience by remembering your preferences and understanding how you use our site.</p>
          </section>

          <section>
            <h2 className="text-base font-pixel mb-4 text-[#9333EA]">How We Use Cookies</h2>
            <p className="mb-4">We use cookies to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Remember your preferences and settings</li>
              <li>Understand how you interact with our website</li>
              <li>Improve your browsing experience</li>
              <li>Enable certain features and functionality</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-pixel mb-4 text-[#9333EA]">Types of Cookies We Use</h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-sm font-medium mb-2 text-white">Essential Cookies</h3>
                <p className="mb-4">Required for the website to function properly. These cannot be disabled.</p>
              </div>
              <div>
                <h3 className="text-sm font-medium mb-2 text-white">Analytics Cookies</h3>
                <p className="mb-4">Help us understand how visitors interact with our website.</p>
              </div>
              <div>
                <h3 className="text-sm font-medium mb-2 text-white">Functionality Cookies</h3>
                <p className="mb-4">Remember your preferences and settings for a better experience.</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-base font-pixel mb-4 text-[#9333EA]">Managing Cookies</h2>
            <p className="mb-4">You can control and manage cookies through your browser settings. Please note that disabling certain cookies may affect the functionality of our website.</p>
          </section>

          <section>
            <h2 className="text-base font-pixel mb-4 text-[#9333EA]">Updates to This Policy</h2>
            <p className="mb-4">We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated revision date.</p>
          </section>
        </div>
      </div>
    </Layout>
  );
} 